(function() { window.GUID_d2bd20cc_ebc8_4078_b344_5f32b975cdac = { getGuid: function() { return "d2bd20cc-ebc8-4078-b344-5f32b975cdac"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        let Action;
        (function (Action) {
            Action["Initialize"] = "initialize";
            Action["Start"] = "start";
            Action["Stop"] = "stop";
            Action["Reset"] = "reset";
            Action["Next"] = "next";
            Action["Previous"] = "previous";
            Action["FullScreen"] = "fullscreen";
        })(Action || (Action = {}));
        let State;
        (function (State) {
            State["Initializing"] = "initializing";
            State["Unready"] = "unready";
            State["Ready"] = "ready";
            State["Running"] = "running";
            State["Stopping"] = "stopping";
            State["Stopped"] = "stopped";
            State["Error"] = "error";
            State["Finished"] = "finished";
        })(State || (State = {}));
        class RacingBarChart extends Controls.ControlBase {
            get renderedBarsCount() {
                if (this.symbols == null) {
                    return 0;
                }
                return Math.min(100, this.symbols.length);
            }
            get visibleBarsCount() {
                return Math.min(this.renderedBarsCount, this.maxVisibleBarsCount);
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            get lang() {
                var _a, _b;
                return (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.Language) !== null && _b !== void 0 ? _b : "en";
            }
            get barHeight() {
                var _a;
                return ((_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.IsMobileDevice) ? 40 : 50;
            }
            get avatarWidth() {
                return (this.barHeight - this.barHeight * this.barPadding - 1 //+ this.spacing / 2 + 1
                );
            }
            get chartHeight() {
                return (this.marginTop +
                    this.barHeight * this.renderedBarsCount +
                    this.marginBottom);
            }
            get chartContainerHeight() {
                return (this.marginTop +
                    this.barHeight * this.visibleBarsCount +
                    this.marginBottom);
            }
            get animationDurations() {
                return Array.from({
                    length: (this.animationDurationMax - this.animationDurationMin) /
                        this.animationDurationStep +
                        1,
                }, (_, i) => this.animationDurationMin + i * this.animationDurationStep);
            }
            // private secondaryHighlightedBarColor = getComputedStyle(
            //   document.documentElement
            // ).getPropertyValue("--brandColor--50");
            get baseTextFontSize() {
                return this.barHeight / 3.75;
            }
            get nameFontSize() {
                return this.baseTextFontSize;
            }
            get valueFontSize() {
                return this.baseTextFontSize * 1.1;
            }
            constructor(controlId, statUserGraphs, orangeEntityBaseIds = [], blueEntityBaseIds = []) {
                super(controlId);
                this.controlId = controlId;
                this.statUserGraphs = statUserGraphs;
                this.orangeEntityBaseIds = orangeEntityBaseIds;
                this.blueEntityBaseIds = blueEntityBaseIds;
                this.state = State.Unready;
                this.dates = [];
                this.symbols = [];
                this.datapoints = [];
                this.datapointsBySymbol = {};
                this.fullScreenButton = null;
                this.quitFullScreenButton = null;
                this.decimalsCount = 0;
                this.minValue = 0;
                this.maxVisibleBarsCount = 10;
                this.interpolationsCount = 7;
                this.resizeTimeout = null;
                this.rankNumberFormat = (value) => `#${d3.format("d")(value)}`;
                this.anyNumbersHaveDecimals = false;
                this.currentKeyframeIndex = 0;
                this.currentDate = "";
                this.interpolatedDatesByDate = new Map();
                this.opponentDetailsURLByEntityBaseId = new Map();
                this.minValueForBarInnerTextByDate = new Map();
                this.chartWidth = 400;
                this.spacing = 8;
                this.barPadding = 0.25;
                this.marginTop = this.spacing * 3;
                this.marginRight = this.avatarWidth + this.spacing * 2;
                this.marginBottom = this.spacing;
                this.marginLeft = this.spacing * 6;
                this.animationDuration = 1000;
                this.previousAnimationDuration = null;
                this.animationDurationMin = 200;
                this.animationDurationMax = 2000;
                this.animationDurationStep = 100;
                this.dateFormat = d3.utcFormat("%B %d, %Y");
                this.xAxisColor = "rgba(255,255,255,0.1)";
                this.rankColor = "rgba(255,255,255,1)";
                this.barTextColor = "rgba(255,255,255,1)";
                this.barFillOpacity = 0.87;
                this.barFillOpacityIsSpare = 0.35;
                this.barColor = "#4B495F";
                this.orangeBarColor = CS.Helper.DataVisualizationHelper.DIVERGENT_PALETTE.orange;
                this.blueBarColor = CS.Helper.DataVisualizationHelper.DIVERGENT_PALETTE.blue;
                this.barTextOpacity = 1;
                this.barTextOpacityIsSpare = 0.7;
                this.avatarOpacity = 1;
                this.avatarOpacityIsSpare = 0.5;
                this.mainHighlightedBarColor = getComputedStyle(document.documentElement).getPropertyValue("--brandColor");
                this.secondaryHighlightedBarColor = `hsl(37, 16%, 55%)`;
                this.mainHighlightedSymbolIds = [];
                this.secondaryHighlightedSymbolIds = [];
                this.$parentWallSection = this.$Control.closest(".main-wall-section-container.accordion-racingbarchart");
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$Control.addClass("racing-bar-chart");
            }
            OnBindEvents() { }
            OnDispose() {
                CS.DOM.$win.off(`resize.RacingBarChart-${this.ControlId}`);
            }
            init() {
                return __awaiter(this, void 0, void 0, function* () {
                    yield this.dispatch(Action.Initialize);
                });
            }
            dispatch(action, payload) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.state == State.Error) {
                            CS.Helper.log("RacingBarChart", "Preventing dispatch due to error.", {
                                action,
                                payload,
                            });
                            return;
                        }
                        switch (action) {
                            case Action.Initialize:
                                yield this.initialize();
                                break;
                            case Action.Start:
                                yield this.start();
                                break;
                            case Action.Stop:
                                yield this.initializeStopSequence();
                                break;
                            case Action.Reset:
                                yield this.reset();
                                break;
                            case Action.Next:
                                yield this.goToNextDate();
                                break;
                            case Action.Previous:
                                yield this.goToPreviousDate();
                                break;
                            case Action.FullScreen:
                                this.toggleFullScreen(payload);
                                break;
                            default:
                                break;
                        }
                    }
                    catch (error) {
                        console.error("Error while dispatching action", error);
                    }
                });
            }
            toggleFullScreen(isFullScreen) {
                try {
                    if (![State.Ready, State.Stopped].includes(this.state)) {
                        CS.Helper.log("RacingBarChart", `Cannot toggle full screen while state is ${this.state}`);
                        return;
                    }
                    CS.Helper.log("RacingBarChart", "Toggling full screen...", isFullScreen);
                }
                catch (error) {
                    console.error("Error while toggling full screen", error);
                }
            }
            reset() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.stop();
                        yield this.goToKeyframe("index", 0);
                    }
                    catch (error) {
                        this.setState(State.Error);
                        console.error("Error while resetting", error);
                    }
                });
            }
            start() {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    try {
                        if (![State.Ready, State.Stopped].includes(this.state)) {
                            CS.Helper.log("RacingBarChart", `Cannot start while state is ${this.state}`);
                            return;
                        }
                        CS.Helper.log("RacingBarChart", "Starting...");
                        this.setState(State.Running);
                        let i = 0;
                        for (const keyframe of this.keyframes) {
                            // Skip the first keyframe since it was rendered in the render() method.
                            if (i++ == 0) {
                                continue;
                            }
                            // Skip the currentKeyframe if it's already been rendered.
                            if (i <= this.currentKeyframeIndex) {
                                continue;
                            }
                            this.currentKeyframeIndex = i;
                            this.currentDate = this.dateFormat(keyframe[0]);
                            const currentDateIsInterpolated = !this.interpolatedDatesByDate.has(this.currentDate);
                            const transition = this.svg
                                .transition()
                                .duration(this.animationDuration)
                                .ease(d3.easeLinear);
                            this.xScale.domain([this.minValue, keyframe[1][0].value]); // Extract the top bar’s value.
                            this.updateAxis(keyframe, transition);
                            this.updateBars(keyframe, transition);
                            this.updateLabels(keyframe, transition);
                            if (!currentDateIsInterpolated) {
                                this.updateTicker(keyframe, transition);
                            }
                            this.updateProgressBar();
                            // invalidation.then(() => svg.interrupt());
                            yield transition.end();
                            if (((_b = (_a = this.$Control) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) <= 0) {
                                this.stop();
                                break;
                            }
                            if (this.state == State.Stopping) {
                                if (!currentDateIsInterpolated) {
                                    this.stop();
                                    break;
                                }
                            }
                            else if (i == this.keyframes.length) {
                                this.setState(State.Finished);
                                break;
                            }
                        }
                    }
                    catch (error) {
                        this.setState(State.Error);
                        console.error("Error while starting", error);
                    }
                });
            }
            stop() {
                var _a;
                (_a = this.svg) === null || _a === void 0 ? void 0 : _a.interrupt();
                this.setState(State.Stopped);
                if (this.previousAnimationDuration) {
                    this.animationDuration = this.previousAnimationDuration;
                    this.previousAnimationDuration = null;
                    this.animationDurationInput.value = this.getReversedAnimationDuration(this.animationDuration).toString();
                }
                CS.Helper.log("RacingBarChart", "Stopped.");
            }
            /**
             * Stops the animation at the next keyframe that is not interpolated.
             * This is because interpolated keyframes are not actual data points.
             * So we don't want to stop the animation at an interpolated keyframe.
             */
            initializeStopSequence() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        CS.Helper.log("RacingBarChart", "Stopping...");
                        this.setState(State.Stopping);
                        this.previousAnimationDuration = this.animationDuration;
                        this.animationDuration = this.animationDurationMin;
                        this.animationDurationInput.value = this.getReversedAnimationDuration(this.animationDuration).toString();
                    }
                    catch (error) {
                        this.setState(State.Error);
                        console.error("Error while stopping", error);
                    }
                });
            }
            initialize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        CS.Helper.log("RacingBarChart", "Initializing...");
                        this.setData();
                        this.createHTML();
                        yield this.setChartDimensions();
                        yield this.render();
                        this.bindEvents();
                        this.setState(State.Ready);
                        CS.Helper.log("RacingBarChart", "Initialized.");
                    }
                    catch (error) {
                        console.error("Error while initializing", error);
                        this.setState(State.Error);
                    }
                });
            }
            goToKeyframe(type, value) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (typeof value !== "number" && typeof value !== "string") {
                            CS.Helper.log("RacingBarChart", "Cannot go to keyframe. Value is not a number or string.");
                            return;
                        }
                        if (type === "index" && typeof value !== "number") {
                            CS.Helper.log("RacingBarChart", "Cannot go to keyframe. Value is not a number, but type is index.");
                            return;
                        }
                        if (type === "date" && typeof value !== "string") {
                            CS.Helper.log("RacingBarChart", "Cannot go to keyframe. Value is not a string, but type is date.");
                            return;
                        }
                        let targetKeyframeIndex = 0;
                        if (type === "date") {
                            targetKeyframeIndex = this.keyframes.findIndex((keyframe) => {
                                return this.dateFormat(keyframe[0]) == value;
                            });
                        }
                        else if (type === "index") {
                            targetKeyframeIndex = Number(value);
                        }
                        if (targetKeyframeIndex < 0) {
                            CS.Helper.log("RacingBarChart", `Cannot find keyframe at index ${value}`);
                            return;
                        }
                        CS.Helper.log("RacingBarChart", `Going to keyframe at index ${targetKeyframeIndex}...`);
                        const shouldReverse = targetKeyframeIndex < this.currentKeyframeIndex;
                        const startIndex = shouldReverse
                            ? targetKeyframeIndex
                            : this.currentKeyframeIndex;
                        const endIndex = shouldReverse
                            ? this.currentKeyframeIndex
                            : targetKeyframeIndex;
                        if (startIndex < 0 || endIndex > this.keyframes.length) {
                            CS.Helper.log("RacingBarChart", "Cannot go to keyframe. Start or end index is out of bounds.", {
                                startIndex,
                                endIndex,
                                keyframesLength: this.keyframes.length,
                            });
                            return;
                        }
                        const targetKeyframe = this.keyframes[targetKeyframeIndex];
                        this.currentKeyframeIndex = targetKeyframeIndex;
                        this.currentDate = this.dateFormat(targetKeyframe[0]);
                        const currentDateIsInterpolated = !this.interpolatedDatesByDate.has(this.currentDate);
                        const transition = this.svg
                            .transition()
                            .duration(0)
                            .ease(d3.easeLinear);
                        this.xScale.domain([this.minValue, targetKeyframe[1][0].value]);
                        this.updateAxis(targetKeyframe, transition);
                        this.updateBars(targetKeyframe, transition);
                        this.updateLabels(targetKeyframe, transition);
                        if (!currentDateIsInterpolated) {
                            this.updateTicker(targetKeyframe, transition);
                        }
                        this.updateProgressBar();
                        yield transition.end();
                        if (this.currentKeyframeIndex == this.keyframes.length - 1) {
                            this.setState(State.Finished);
                        }
                        else if (this.currentKeyframeIndex == 0) {
                            this.setState(State.Ready);
                        }
                        else {
                            this.setState(State.Stopped);
                        }
                    }
                    catch (error) {
                        this.setState(State.Error);
                        console.error("Error while going to keyframe", error);
                    }
                });
            }
            goToNextDate() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.currentKeyframeIndex >= this.keyframes.length) {
                            return;
                        }
                        let nextKeyframeIndex = this.currentKeyframeIndex + 1;
                        let nextKeyframe = this.keyframes[nextKeyframeIndex];
                        const currentNonInterpolatedDate = this.dateSelector.value;
                        while (nextKeyframeIndex < this.keyframes.length &&
                            (!this.dates.includes(this.dateFormat(nextKeyframe[0])) ||
                                this.dateFormat(nextKeyframe[0]) == currentNonInterpolatedDate)) {
                            nextKeyframeIndex++;
                            nextKeyframe = this.keyframes[nextKeyframeIndex];
                        }
                        if (nextKeyframeIndex >= this.keyframes.length) {
                            return;
                        }
                        yield this.goToKeyframe("index", nextKeyframeIndex);
                    }
                    catch (error) {
                        console.error("Error while going to next date", error);
                    }
                });
            }
            goToPreviousDate() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.currentKeyframeIndex <= 0) {
                            return;
                        }
                        let previousKeyframeIndex = this.currentKeyframeIndex - 1;
                        let previousKeyframe = this.keyframes[previousKeyframeIndex];
                        const currentNonInterpolatedDate = this.dateSelector.value;
                        while (previousKeyframeIndex >= 0 &&
                            (!this.dates.includes(this.dateFormat(previousKeyframe[0])) ||
                                this.dateFormat(previousKeyframe[0]) == currentNonInterpolatedDate)) {
                            previousKeyframeIndex--;
                            previousKeyframe = this.keyframes[previousKeyframeIndex];
                        }
                        if (previousKeyframeIndex < 0) {
                            return;
                        }
                        yield this.goToKeyframe("index", previousKeyframeIndex);
                    }
                    catch (error) {
                        console.error("Error while going to previous date", error);
                    }
                });
            }
            updateProgressBar() {
                var _a, _b;
                if (this.currentKeyframeIndex == 1) {
                    // Progress bar shouldn't be updated for the first keyframe
                    return;
                }
                try {
                    if (!this.progressBar) {
                        throw new Error("Progress bar element not found.");
                    }
                    if (!this.keyframes) {
                        throw new Error("Keyframes not found.");
                    }
                    const progressBarFill = this.progressBar.querySelector(".racing-bar-chart__progress-bar__fill");
                    if (!progressBarFill) {
                        throw new Error("Progress bar fill element not found.");
                    }
                    if (this.currentKeyframeIndex < 0) {
                        progressBarFill === null || progressBarFill === void 0 ? void 0 : progressBarFill.style.setProperty("max-width", "0%");
                        return;
                    }
                    if ((_b = (_a = this.$Control) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) {
                        const currentKeyframeMarker = this.$Control[0].querySelector(`.racing-bar-chart__progress-marker-container[data-date="${this.currentDate}"]`);
                        if (currentKeyframeMarker) {
                            const progress = currentKeyframeMarker.dataset.progress;
                            if (progress) {
                                progressBarFill === null || progressBarFill === void 0 ? void 0 : progressBarFill.style.setProperty("max-width", `${progress}%`);
                            }
                        }
                    }
                }
                catch (error) {
                    console.error("Error while updating the progress bar.", error);
                    this.setState(State.Error);
                    return;
                }
            }
            bindEvents() {
                try {
                    this.startButton.addEventListener("click", () => {
                        this.dispatch(Action.Start);
                    });
                    this.stopButton.addEventListener("click", () => {
                        this.dispatch(Action.Stop);
                    });
                    this.resetButton.addEventListener("click", () => {
                        this.dispatch(Action.Reset);
                    });
                    this.nextButton.addEventListener("click", () => {
                        this.dispatch(Action.Next, 1);
                    });
                    this.previousButton.addEventListener("click", () => {
                        this.dispatch(Action.Previous, 1);
                    });
                    this.progressBar.addEventListener("click", this.handleProgressBarClick.bind(this));
                    this.dateSelector.addEventListener("change", this.handleDateSelection.bind(this));
                    this.animationDurationInput.addEventListener("change", (event) => {
                        try {
                            const target = event.target;
                            const value = parseInt(target.value);
                            this.animationDuration = this.getReversedAnimationDuration(value);
                        }
                        catch (error) {
                            console.error("Error while changing animation duration", error);
                        }
                    });
                    CS.DOM.$win.offon(`resize.RacingBarChart-${this.ControlId}`, this.handleResize.bind(this));
                    CS.DOM.$body.offon(`click.RacingBarChart-${this.ControlId}-symbol`, `#${this.ControlId} .racing-bar-chart__bar, #${this.ControlId} .racing-bar-chart__avatar`, this.handleSymbolClick.bind(this));
                    // this.$Control.offon(
                    //   "click.legendItemClicked",
                    //   ".chart__legend-item",
                    //   this.handleLegendItemClick.bind(this)
                    // );
                    if (this.fullScreenButton != null) {
                        this.fullScreenButton.addEventListener("click", () => {
                            this.dispatch(Action.FullScreen, true);
                        });
                    }
                    if (this.quitFullScreenButton != null) {
                        this.quitFullScreenButton.addEventListener("click", () => {
                            this.dispatch(Action.FullScreen, false);
                        });
                    }
                }
                catch (error) {
                    console.error("Error while binding events", error);
                }
            }
            // private handleLegendItemClick(event: Event) {
            //   try {
            //     const $clickedItem = $(event.currentTarget);
            //     const clickedItemDataSymbol = $clickedItem.attr("data-symbol");
            //     if (!clickedItemDataSymbol) {
            //       throw new Error("Symbol not found.");
            //     }
            //     const clickedItemSymbol = Number(clickedItemDataSymbol);
            //     if (isNaN(clickedItemSymbol)) {
            //       throw new Error("Symbol is not a number.");
            //     }
            //     const onClass = "selected";
            //     const offClass = "not-selected";
            //     const $legend = $clickedItem.closest(".chart__legend");
            //     const $items = $legend.find(".chart__legend-item");
            //     const $bars = this.$Control.find(".chart__bar");
            //     const $avatars = this.$Control.find(".chart__avatar");
            //     const $barLabels = this.$Control.find(".chart__bar-label");
            //     const $tickLabels = this.$Control.find(".chart__tick-label");
            //     const $avatarRects = this.$Control.find(".chart__avatar-rect");
            //     const wasSelected = $clickedItem.hasClass(onClass);
            //     $clickedItem.toggleClass(onClass, !wasSelected);
            //     const anyItemSelected = $items
            //       .toArray()
            //       .some((item) => $(item).hasClass(onClass));
            //     this.symbols.forEach((dataSymbol) => {
            //       const $item = $legend.find(`[data-symbol="${dataSymbol}"]`);
            //       const symbol = Number(dataSymbol);
            //       if (isNaN(symbol)) {
            //         return;
            //       }
            //       const isSelected = $item.hasClass(onClass);
            //       const $bar = $bars.filter(`[data-id="${symbol}"]`);
            //       const $avatar = $avatars.filter(`[data-symbol="${symbol}"]`);
            //       const $barLabel = $barLabels.filter(`[data-symbol="${symbol}"]`);
            //       const $tickLabel = $tickLabels.filter(`[data-symbol="${symbol}"]`);
            //       const $avatarRect = $avatarRects.filter(`[data-symbol="${symbol}"]`);
            //       if (!anyItemSelected) {
            //         $item.removeClass(offClass);
            //         $bar.removeClass(offClass);
            //         $avatar.removeClass(offClass);
            //         $barLabel.removeClass(offClass);
            //         $tickLabel.removeClass(offClass);
            //         $avatarRect.removeClass(offClass);
            //       } else {
            //         if (isSelected) {
            //           $item.removeClass(offClass);
            //           $bar.removeClass(offClass);
            //           $avatar.removeClass(offClass);
            //           $barLabel.removeClass(offClass);
            //           $tickLabel.removeClass(offClass);
            //           $avatarRect.removeClass(offClass);
            //         } else {
            //           $item.addClass(offClass);
            //           $bar.addClass(offClass);
            //           $avatar.addClass(offClass);
            //           $barLabel.addClass(offClass);
            //           $tickLabel.addClass(offClass);
            //           $avatarRect.addClass(offClass);
            //         }
            //       }
            //     });
            //   } catch (error) {
            //     console.error("Error while handling legend item click.", error);
            //   }
            // }
            handleSymbolClick(event) {
                var _a, _b, _c;
                try {
                    if (![State.Ready, State.Stopped, State.Finished].includes(this.state)) {
                        CS.Helper.log("RacingBarChart", `Cannot handle symbol click. State is ${this.state}`);
                        return;
                    }
                    const bar = event.target.closest(".racing-bar-chart__bar");
                    const avatar = event.target.closest(".racing-bar-chart__avatar");
                    let id = (_b = (_a = bar === null || bar === void 0 ? void 0 : bar.attributes.getNamedItem("data-id")) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : (_c = avatar === null || avatar === void 0 ? void 0 : avatar.attributes.getNamedItem("data-id")) === null || _c === void 0 ? void 0 : _c.value;
                    const url = this.opponentDetailsURLByEntityBaseId.get(parseInt(id));
                    if (url) {
                        Controls.Popup.ShowAjaxModal(url, {}, (p) => { }, (p) => { }, true);
                    }
                }
                catch (error) {
                    console.error("Error while handling symbol click", error);
                }
            }
            handleProgressBarClick(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (![State.Ready, State.Stopped, State.Finished].includes(this.state)) {
                            CS.Helper.log("RacingBarChart", `Cannot handle progress bar click. State is ${this.state}`);
                            return;
                        }
                        let markerElement = null;
                        if (event.target.closest(".racing-bar-chart__progress-marker-container")) {
                            markerElement = event.target.closest(".racing-bar-chart__progress-marker-container");
                        }
                        if (!markerElement) {
                            return;
                        }
                        const index = markerElement.dataset.index;
                        const date = markerElement.dataset.date;
                        if (index == null || date == null) {
                            throw new Error("Index or date not found.");
                        }
                        yield this.goToKeyframe("index", parseInt(index));
                    }
                    catch (error) {
                        console.error("Error while handling progress bar click", error);
                    }
                });
            }
            handleDateSelection(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (![State.Ready, State.Stopped, State.Finished].includes(this.state)) {
                            CS.Helper.log("RacingBarChart", `Cannot handle date selection. State is ${this.state}`);
                            return;
                        }
                        const date = event.target.value;
                        if (date == null) {
                            throw new Error("Date not found.");
                        }
                        yield this.goToKeyframe("date", date);
                    }
                    catch (error) {
                        console.error("Error while handling date selection", error);
                    }
                });
            }
            setState(newState) {
                if (this.state == newState) {
                    return;
                }
                CS.Helper.log("RacingBarChart", `Setting state from ${this.state} to ${newState}`);
                this.state = newState;
                this.updateUI();
            }
            updateUI() {
                try {
                    switch (this.state) {
                        case State.Initializing:
                            this.startButton.setAttribute("disabled", "true");
                            this.stopButton.setAttribute("disabled", "true");
                            this.nextButton.setAttribute("disabled", "true");
                            this.previousButton.setAttribute("disabled", "true");
                            this.resetButton.setAttribute("disabled", "true");
                            // this.selectEntityElement?.setAttribute("disabled", "true");
                            this.dateSelector.setAttribute("disabled", "true");
                            this.chartContainer.style.setProperty("opacity", "0.5");
                            this.animationDurationInput.setAttribute("disabled", "true");
                            this.animationDurationInput.style.setProperty("opacity", "0.5");
                            break;
                        case State.Unready:
                            this.startButton.setAttribute("disabled", "true");
                            this.stopButton.setAttribute("disabled", "true");
                            this.nextButton.setAttribute("disabled", "true");
                            this.previousButton.setAttribute("disabled", "true");
                            this.resetButton.setAttribute("disabled", "true");
                            // this.selectEntityElement?.setAttribute("disabled", "true");
                            this.dateSelector.setAttribute("disabled", "true");
                            this.chartContainer.style.setProperty("opacity", "0.5");
                            this.animationDurationInput.setAttribute("disabled", "true");
                            this.animationDurationInput.style.setProperty("opacity", "0.5");
                            break;
                        case State.Ready:
                            this.startButton.removeAttribute("disabled");
                            this.stopButton.setAttribute("disabled", "true");
                            this.nextButton.removeAttribute("disabled");
                            this.previousButton.setAttribute("disabled", "true");
                            this.resetButton.setAttribute("disabled", "true");
                            // this.selectEntityElement?.removeAttribute("disabled");
                            this.dateSelector.removeAttribute("disabled");
                            this.chartContainer.style.setProperty("opacity", "1");
                            this.animationDurationInput.removeAttribute("disabled");
                            this.animationDurationInput.style.setProperty("opacity", "1");
                            break;
                        case State.Running:
                            this.startButton.setAttribute("disabled", "true");
                            this.stopButton.removeAttribute("disabled");
                            this.nextButton.setAttribute("disabled", "true");
                            this.previousButton.setAttribute("disabled", "true");
                            this.resetButton.setAttribute("disabled", "true");
                            // this.selectEntityElement?.setAttribute("disabled", "true");
                            this.dateSelector.setAttribute("disabled", "true");
                            this.animationDurationInput.removeAttribute("disabled");
                            this.animationDurationInput.style.setProperty("opacity", "1");
                            break;
                        case State.Stopping:
                            this.startButton.setAttribute("disabled", "true");
                            this.stopButton.setAttribute("disabled", "true");
                            this.nextButton.setAttribute("disabled", "true");
                            this.previousButton.setAttribute("disabled", "true");
                            this.resetButton.setAttribute("disabled", "true");
                            // this.selectEntityElement?.setAttribute("disabled", "true");
                            this.dateSelector.setAttribute("disabled", "true");
                            this.animationDurationInput.setAttribute("disabled", "true");
                            this.animationDurationInput.style.setProperty("opacity", "0.5");
                            break;
                        case State.Stopped:
                            this.startButton.removeAttribute("disabled");
                            this.stopButton.setAttribute("disabled", "true");
                            this.nextButton.removeAttribute("disabled");
                            this.previousButton.removeAttribute("disabled");
                            this.resetButton.removeAttribute("disabled");
                            // this.selectEntityElement?.removeAttribute("disabled");
                            this.dateSelector.removeAttribute("disabled");
                            this.animationDurationInput.removeAttribute("disabled");
                            this.animationDurationInput.style.setProperty("opacity", "1");
                            break;
                        case State.Error:
                            this.startButton.setAttribute("disabled", "true");
                            this.stopButton.setAttribute("disabled", "true");
                            this.nextButton.setAttribute("disabled", "true");
                            this.previousButton.setAttribute("disabled", "true");
                            this.resetButton.setAttribute("disabled", "true");
                            // this.selectEntityElement?.setAttribute("disabled", "true");
                            this.dateSelector.setAttribute("disabled", "true");
                            this.chartContainer.style.setProperty("opacity", "0.5");
                            this.animationDurationInput.setAttribute("disabled", "true");
                            this.animationDurationInput.style.setProperty("opacity", "0.5");
                            break;
                        case State.Finished:
                            this.startButton.setAttribute("disabled", "true");
                            this.stopButton.setAttribute("disabled", "true");
                            this.nextButton.setAttribute("disabled", "true");
                            this.previousButton.removeAttribute("disabled");
                            this.resetButton.removeAttribute("disabled");
                            // this.selectEntityElement?.removeAttribute("disabled");
                            this.dateSelector.removeAttribute("disabled");
                            this.animationDurationInput.removeAttribute("disabled");
                            this.animationDurationInput.style.setProperty("opacity", "1");
                            break;
                        default:
                            break;
                    }
                }
                catch (error) {
                    console.error("Error while updating UI", error);
                }
            }
            getDefaultEntityBaseIdColor(entityBaseId) {
                try {
                    if (!this.orangeEntityBaseIds.length ||
                        !this.blueEntityBaseIds.length) {
                        return "";
                    }
                    if (this.orangeEntityBaseIds.includes(entityBaseId)) {
                        return CS.Helper.DataVisualizationHelper.DIVERGENT_PALETTE[0];
                    }
                    if (this.blueEntityBaseIds.includes(entityBaseId)) {
                        return CS.Helper.DataVisualizationHelper.DIVERGENT_PALETTE[1];
                    }
                    return "";
                }
                catch (error) {
                    console.error("Error while getting default entity base ID color", error);
                }
            }
            setData() {
                try {
                    if (this.statUserGraphs == null) {
                        throw new Error("Data not found.");
                    }
                    this.datapoints = this.statUserGraphs
                        .map((statUserGraph, index) => {
                        var _a;
                        const date = new Date(statUserGraph.StatDateString);
                        const timestamp = statUserGraph.StatDateTimestamp;
                        const statFieldName = statUserGraph.StatFieldName;
                        let label = CS.Helper.formatString(JSRess.YOfX, statUserGraph.DisplayName, statFieldName);
                        let displayName = statUserGraph.DisplayName;
                        if (statUserGraph.IsSpare) {
                            const spareSuffix = ` (S)`;
                            label += spareSuffix;
                            displayName += spareSuffix;
                        }
                        const datapoint = {
                            id: statUserGraph.EntityBaseId,
                            symbolId: statUserGraph.EntityBaseId,
                            label: label,
                            displayName: displayName,
                            date: date,
                            timestamp: timestamp,
                            entityBaseId: statUserGraph.EntityBaseId,
                            displayValue: statUserGraph.DisplayValue,
                            rankingValue: statUserGraph.Value,
                            statName: statFieldName,
                            avatar: statUserGraph.OpponentImageUrl,
                            avatarFallback: (_a = statUserGraph.DefaultImageUrl) !== null && _a !== void 0 ? _a : "",
                            color: this.getDefaultEntityBaseIdColor(statUserGraph.EntityBaseId),
                            premiumLocked: statUserGraph.PremiumLocked,
                            isSpare: statUserGraph.IsSpare,
                        };
                        if (!this.secondaryHighlightedSymbolIds.includes(statUserGraph.EntityBaseId) &&
                            statUserGraph.IsHighlightedMain) {
                            this.mainHighlightedSymbolIds.push(statUserGraph.EntityBaseId);
                        }
                        else if (!this.secondaryHighlightedSymbolIds.includes(statUserGraph.EntityBaseId) &&
                            statUserGraph.IsHighlightedSecondary) {
                            this.secondaryHighlightedSymbolIds.push(statUserGraph.EntityBaseId);
                        }
                        // Set an entry in opponentDetailsURLByEntityBaseId map if it doesn't exist
                        if (statUserGraph.OpponentDetailsPopupUrl &&
                            !this.opponentDetailsURLByEntityBaseId.has(statUserGraph.EntityBaseId)) {
                            this.opponentDetailsURLByEntityBaseId.set(statUserGraph.EntityBaseId, statUserGraph.OpponentDetailsPopupUrl);
                        }
                        return datapoint;
                    })
                        .sort((a, b) => {
                        return a.timestamp - b.timestamp;
                    });
                    if (this.datapoints.length) {
                        this.minValue = d3.min(this.datapoints, (d) => d.displayValue);
                    }
                    const symbolIds = this.statUserGraphs
                        .map((statUserGraph) => {
                        return statUserGraph.EntityBaseId;
                    })
                        .filter((value, index, self) => {
                        return self.indexOf(value) === index;
                    });
                    this.symbols = symbolIds
                        .map((symbolId) => {
                        const statUserGraph = this.statUserGraphs.find((statUserGraph) => statUserGraph.EntityBaseId == symbolId);
                        if (statUserGraph == null) {
                            return null;
                        }
                        const symbol = {
                            id: statUserGraph.EntityBaseId,
                            entityBaseId: statUserGraph.EntityBaseId,
                            statFieldId: statUserGraph.StatFieldId,
                            displayName: statUserGraph.DisplayName,
                            avatar: statUserGraph.OpponentImageUrl,
                        };
                        return symbol;
                    })
                        .filter((symbol) => symbol != null);
                    this.symbols.forEach((symbol) => {
                        const datapoints = this.datapoints.filter((datapoint) => {
                            return datapoint.symbolId === symbol.id;
                        });
                        this.datapointsBySymbol[symbol.id] = datapoints;
                    });
                    const displayValuesByDate = Array.from(d3.rollup(this.datapoints, // iterable
                    ([d]) => d.displayValue, // reduce
                    (d) => d.date, // key1
                    (d) => d.id // key2
                    ))
                        .map(([date, data]) => [new Date(date), data])
                        .sort(([a], [b]) => d3.ascending(a, b));
                    const displayValueKeyframes = [];
                    let displayValuesKeyA;
                    let displayValuesA;
                    let displayValuesKeyB;
                    let displayValuesB;
                    for ([
                        [displayValuesKeyA, displayValuesA],
                        [displayValuesKeyB, displayValuesB],
                    ] of d3.pairs(displayValuesByDate)) {
                        for (let i = 0; i < this.interpolationsCount; ++i) {
                            const t = i / this.interpolationsCount;
                            displayValueKeyframes.push([
                                new Date(displayValuesKeyA * (1 - t) + displayValuesKeyB * t),
                                this.rank((id) => (displayValuesA.get(id) || 0) * (1 - t) +
                                    (displayValuesB.get(id) || 0) * t),
                            ]);
                        }
                    }
                    displayValueKeyframes.push([
                        new Date(displayValuesKeyB),
                        this.rank((id) => displayValuesB.get(id) || 0),
                    ]);
                    displayValueKeyframes.forEach(([date, data]) => {
                        if (!this.minValueForBarInnerTextByDate.has(date)) {
                            // minValue should be the ABSOLUTE MIN of all datapoints since it doesn't change. It's ok for the maxValue to change.
                            const minValue = this.minValue;
                            const maxValue = d3.max(data, (d) => d.value);
                            if (!isNaN(minValue) && !isNaN(maxValue)) {
                                const average = d3.mean([minValue, maxValue]);
                                const diff = maxValue - minValue;
                                const half = diff / 2;
                                const result = minValue + half;
                                const minValueForBarInner = result;
                                this.minValueForBarInnerTextByDate.set(date, minValueForBarInner);
                            }
                        }
                    });
                    const rankingValuesByDate = Array.from(d3.rollup(this.datapoints, // iterable
                    ([d]) => d.rankingValue, // reduce
                    (d) => d.date, // key1
                    (d) => d.id // key2
                    ))
                        .map(([date, data]) => [new Date(date), data])
                        .sort(([a], [b]) => d3.ascending(a, b));
                    const rankingValueKeyframes = [];
                    let rankingValuesKeyA;
                    let rankingValuesA;
                    let rankingValuesKeyB;
                    let rankingValuesB;
                    for ([
                        [rankingValuesKeyA, rankingValuesA],
                        [rankingValuesKeyB, rankingValuesB],
                    ] of d3.pairs(rankingValuesByDate)) {
                        for (let i = 0; i < this.interpolationsCount; ++i) {
                            const t = i / this.interpolationsCount;
                            rankingValueKeyframes.push([
                                new Date(rankingValuesKeyA * (1 - t) + rankingValuesKeyB * t),
                                this.rank((id) => (rankingValuesA.get(id) || 0) * (1 - t) +
                                    (rankingValuesB.get(id) || 0) * t),
                            ]);
                        }
                    }
                    rankingValueKeyframes.push([
                        new Date(rankingValuesKeyB),
                        this.rank((id) => rankingValuesB.get(id) || 0),
                    ]);
                    this.keyframes = displayValueKeyframes.map(([date, keyframes]) => [
                        date,
                        keyframes.map((keyframe) => {
                            const rankingValue = rankingValueKeyframes
                                .find(([rankingDate, rankingValues]) => {
                                return rankingDate.getTime() == date.getTime();
                            })[1]
                                .find((datapoint) => {
                                return datapoint.id == keyframe.id;
                            }).value;
                            return Object.assign({ rank: rankingValue }, keyframe);
                        }),
                    ]);
                    this.dates = displayValuesByDate.map(([date, data]) => this.dateFormat(date));
                    this.idframes = d3.groups(this.keyframes.flatMap(([, data]) => data), (d) => d.id);
                    this.previousItemsMap = new Map(this.idframes.flatMap(([, data]) => d3.pairs(data, (a, b) => [b, a])));
                    this.nextItemsMap = new Map(this.idframes.flatMap(([, data]) => d3.pairs(data)));
                    let currentDate = this.dateFormat(this.keyframes[0][0]);
                    for (const keyframe of this.keyframes) {
                        const keyframeDate = this.dateFormat(keyframe[0]);
                        const date = this.dates.find((date) => {
                            return date == keyframeDate;
                        });
                        if (date) {
                            this.interpolatedDatesByDate.set(date, [keyframeDate]);
                            currentDate = keyframeDate;
                        }
                        else {
                            const interpolatedDates = this.interpolatedDatesByDate.get(currentDate);
                            if (interpolatedDates) {
                                interpolatedDates.push(keyframeDate);
                            }
                        }
                    }
                    this.anyNumbersHaveDecimals = this.datapoints.some((d) => {
                        return Math.floor(d.displayValue) !== d.displayValue;
                    });
                    let maxDecimalsCount = 0;
                    if (this.anyNumbersHaveDecimals) {
                        this.datapoints.forEach((d) => {
                            var _a, _b;
                            const decimals = (_b = (_a = d.displayValue.toString().split(".")[1]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
                            maxDecimalsCount = Math.max(maxDecimalsCount, decimals);
                        });
                        if (isNaN(maxDecimalsCount)) {
                            maxDecimalsCount = 0;
                        }
                        this.decimalsCount = maxDecimalsCount;
                        if (this.decimalsCount > 0) {
                            this.valueNumberFormat = d3.format(`.${maxDecimalsCount}f`);
                        }
                        else {
                            this.valueNumberFormat = d3.format("d");
                        }
                    }
                    else {
                        this.valueNumberFormat = d3.format("d");
                    }
                }
                catch (error) {
                    console.error("Error while setting data", error);
                }
            }
            rank(value) {
                const ids = new Set(this.datapoints.map((d) => d.id));
                let result = Array.from(ids, (id) => {
                    const datapoint = {
                        id,
                        value: value(id),
                        rank: -1,
                        name: this.datapoints.find((d) => d.id == id).displayName,
                        avatar: this.datapoints.find((d) => d.id == id).avatar,
                        avatarFallback: this.datapoints.find((d) => d.id == id)
                            .avatarFallback,
                        isSpare: this.datapoints.find((d) => d.id == id).isSpare,
                    };
                    return datapoint;
                });
                result.sort((a, b) => d3.descending(a.value, b.value));
                for (let i = 0; i < result.length; ++i)
                    result[i].rank = Math.min(this.renderedBarsCount, i);
                return result;
            }
            createHTML() {
                try {
                    // if (this.$parentWallSection.length) {
                    //   this.createQuitFullScreenButtonElement();
                    // }
                    this.createLegendElement();
                    this.createChartContainerElement();
                    this.createDateSelectionElement();
                    this.createProgressBarElement();
                    this.createUserControlsElement();
                    this.createAnimationDurationControlElement();
                    // if (this.$parentWallSection.length) {
                    //   this.createFullScreenButtonElement();
                    // }
                }
                catch (error) {
                    console.error("Error while creating HTML", error);
                }
            }
            createLegendElement() {
                try {
                    const element = document.createElement("div");
                    element.id = `racing-bar-chart__legend-${this.controlId}`;
                    element.classList.add("racing-bar-chart__legend");
                    element.classList.add("chart__legend");
                    this.$Control.append(element);
                    this.legend = element;
                }
                catch (error) {
                    console.error("Error while creating legend element", error);
                }
            }
            updateLegend(date) {
                try {
                    if (this.legend == null) {
                        throw new Error("Legend element not found.");
                    }
                    if (!this.symbols.length) {
                        throw new Error("Players not found.");
                    }
                    this.legend.innerHTML = "";
                    const currentDate = date !== null && date !== void 0 ? date : this.currentDate;
                    // Create a map of rankingValue to HTML Content
                    const rankingValueToHtmlContentMap = new Map();
                    this.symbols.forEach((symbol) => {
                        const datapoints = this.datapointsBySymbol[symbol.id];
                        const currentDatapoint = datapoints.find((d) => {
                            return this.dateFormat(d.date) == currentDate;
                        });
                        if (!currentDatapoint) {
                            return;
                        }
                        const isMainHighlighted = this.mainHighlightedSymbolIds.includes(symbol.id);
                        const isSecondaryHighlighted = !isMainHighlighted &&
                            this.secondaryHighlightedSymbolIds.includes(symbol.id);
                        const isHighlighted = isMainHighlighted || isSecondaryHighlighted;
                        if (!isHighlighted) {
                            return;
                        }
                        const dateKeyframes = this.keyframes.find(([date]) => {
                            return this.dateFormat(date) == currentDate;
                        });
                        const currentKeyframe = dateKeyframes[1].find((d) => {
                            return d.id == symbol.id;
                        });
                        if (!currentKeyframe) {
                            return;
                        }
                        const rank = currentKeyframe.rank + 1;
                        const color = isMainHighlighted
                            ? this.mainHighlightedBarColor
                            : this.secondaryHighlightedBarColor;
                        const legendItemHtml = `
            <div class="racing-bar-chart__legend-item chart__legend-item" data-symbol="${symbol.id}">
              <div class="racing-bar-chart__legend-item__dot chart__legend-item__dot" style="background-color: ${color};"></div>
              <div class="racing-bar-chart__legend-item__label chart__legend-item__label">${symbol.displayName}</div>
              <span>&nbsp;</span>
              <div class="racing-bar-chart__legend-item__value chart__legend-item__value">${currentDatapoint.displayValue}</div>
              <span>&nbsp;</span>
              <div class="racing-bar-chart__legend-item__sub-value chart__legend-item__sub-value">(#${rank})</div>
            </div>`;
                        // this.legend.insertAdjacentHTML("beforeend", legendItemHtml);
                        rankingValueToHtmlContentMap.set(rank, legendItemHtml);
                    });
                    // Sort the map by rankingValue
                    const sortedRankingValueToHtmlContentMap = new Map([...rankingValueToHtmlContentMap.entries()].sort((a, b) => a[0] - b[0]));
                    sortedRankingValueToHtmlContentMap.forEach((htmlContent) => {
                        this.legend.insertAdjacentHTML("beforeend", htmlContent);
                    });
                }
                catch (error) {
                    console.error("Error while updating legend", error);
                }
            }
            createChartContainerElement() {
                try {
                    const element = document.createElement("div");
                    element.id = `racing-bar-chart__container-${this.controlId}`;
                    element.classList.add("racing-bar-chart__container");
                    element.style.height = `${this.chartContainerHeight}px`;
                    element.style.overflow = "auto";
                    this.$Control.append(element);
                    this.chartContainer = element;
                }
                catch (error) {
                    console.error("Error while creating chart container element", error);
                }
            }
            createUserControlsElement() {
                try {
                    const buttonClasses = [
                        "racing-bar-chart__button",
                        "button--transparent",
                        "csico-btn",
                        "button",
                    ];
                    const element = document.createElement("div");
                    element.id = `racing-bar-chart__user-controls-${this.controlId}`;
                    element.classList.add("racing-bar-chart__user-controls");
                    const baseControlsElement = document.createElement("div");
                    baseControlsElement.id = `racing-bar-chart__user-controls__base-${this.controlId}`;
                    baseControlsElement.classList.add("racing-bar-chart__user-controls__base");
                    const leftGroup = document.createElement("div");
                    leftGroup.classList.add("racing-bar-chart-buttons-group", "racing-bar-chart__left-group");
                    baseControlsElement.appendChild(leftGroup);
                    const middleGroup = document.createElement("div");
                    middleGroup.classList.add("racing-bar-chart-buttons-group", "racing-bar-chart__middle-group");
                    baseControlsElement.appendChild(middleGroup);
                    const rightGroup = document.createElement("div");
                    rightGroup.classList.add("racing-bar-chart-buttons-group", "racing-bar-chart__right-group");
                    baseControlsElement.appendChild(rightGroup);
                    const previousButton = document.createElement("button");
                    previousButton.id = `racing-bar-chart__previous-button-${this.controlId}`;
                    previousButton.classList.add("racing-bar-chart__previous-button", ...buttonClasses);
                    previousButton.innerHTML = `<div class="icon ic-cs-media-controls-previous"></div>`;
                    previousButton.title = "Previous";
                    leftGroup.appendChild(previousButton);
                    const stopButton = document.createElement("button");
                    stopButton.id = `racing-bar-chart__stop-button-${this.controlId}`;
                    stopButton.classList.add("racing-bar-chart__stop-button", ...buttonClasses);
                    stopButton.innerHTML = `<div class="icon ic-cs-media-controls-pause"></div>`;
                    stopButton.title = "Stop";
                    middleGroup.appendChild(stopButton);
                    const playButton = document.createElement("button");
                    playButton.id = `racing-bar-chart__play-button-${this.controlId}`;
                    playButton.classList.add("racing-bar-chart__play-button", ...buttonClasses);
                    playButton.innerHTML = `<div class="icon ic-cs-media-controls-play"></div>`;
                    playButton.title = "Play";
                    middleGroup.appendChild(playButton);
                    const resetButton = document.createElement("button");
                    resetButton.id = `racing-bar-chart__reset-button-${this.controlId}`;
                    resetButton.classList.add("racing-bar-chart__reset-button", ...buttonClasses);
                    resetButton.innerHTML = `<div class="icon ic-cs-arrow-undo"></div>`;
                    resetButton.title = "Reset";
                    middleGroup.appendChild(resetButton);
                    const nextButton = document.createElement("button");
                    nextButton.id = `racing-bar-chart__next-button-${this.controlId}`;
                    nextButton.classList.add("racing-bar-chart__next-button", ...buttonClasses);
                    nextButton.innerHTML = `<div class="icon ic-cs-media-controls-next"></div>`;
                    nextButton.title = "Next";
                    rightGroup.appendChild(nextButton);
                    element.appendChild(baseControlsElement);
                    this.$Control.append(element);
                    this.previousButton = previousButton;
                    this.startButton = playButton;
                    this.stopButton = stopButton;
                    this.resetButton = resetButton;
                    this.nextButton = nextButton;
                }
                catch (error) {
                    console.error("Error while creating user controls element", error);
                }
            }
            createAnimationDurationControlElement() {
                try {
                    const element = document.createElement("div");
                    element.id = `racing-bar-chart__user-controls__advanced-${this.controlId}`;
                    element.classList.add("racing-bar-chart__user-controls__advanced");
                    const animationDurationInputContainerElement = document.createElement("div");
                    animationDurationInputContainerElement.classList.add("racing-bar-chart__user-controls__animation-duration-container");
                    const animationDurationTextElement = document.createElement("p");
                    animationDurationTextElement.classList.add("racing-bar-chart__user-controls__animation-duration-text");
                    animationDurationTextElement.textContent = JSRess.AnimationSpeed;
                    const animationDurationInputElement = document.createElement("input");
                    animationDurationInputElement.id = `racing-bar-chart__user-controls__animation-duration-${this.controlId}`;
                    animationDurationInputElement.classList.add("racing-bar-chart__user-controls__animation-duration");
                    animationDurationInputElement.type = "range";
                    animationDurationInputElement.min =
                        this.animationDurationMin.toString();
                    animationDurationInputElement.max =
                        this.animationDurationMax.toString();
                    animationDurationInputElement.step =
                        this.animationDurationStep.toString();
                    const animationDuration = this.getReversedAnimationDuration(this.animationDuration);
                    animationDurationInputElement.value = animationDuration.toString();
                    animationDurationInputElement.title = "Speed of the animation";
                    animationDurationInputElement.name = "animation-duration";
                    element.appendChild(animationDurationTextElement);
                    animationDurationInputContainerElement.appendChild(animationDurationInputElement);
                    element.appendChild(animationDurationInputContainerElement);
                    this.$Control.append(element);
                    this.animationDurationInput = animationDurationInputElement;
                }
                catch (error) {
                    console.error("Error while creating animation duration control element", error);
                }
            }
            createFullScreenButtonElement() {
                try {
                    const container = document.createElement("div");
                    container.classList.add("racing-bar-chart__full-screen-button-container");
                    const fullScreenButton = document.createElement("button");
                    fullScreenButton.id = `racing-bar-chart__full-screen-button-${this.controlId}`;
                    fullScreenButton.classList.add("racing-bar-chart__full-screen-button", "button", "button--transparent");
                    fullScreenButton.type = "button";
                    fullScreenButton.innerText = JSRess.FullScreen;
                    container.appendChild(fullScreenButton);
                    this.$Control.append(container);
                    this.fullScreenButton = fullScreenButton;
                }
                catch (error) {
                    console.error("Error while creating full screen button element", error);
                }
            }
            createQuitFullScreenButtonElement() {
                try {
                    const container = document.createElement("div");
                    container.classList.add("racing-bar-chart__quit-full-screen-button-container");
                    const quitFullScreenButton = document.createElement("button");
                    quitFullScreenButton.id = `racing-bar-chart__quit-full-screen-button-${this.controlId}`;
                    quitFullScreenButton.classList.add("racing-bar-chart__quit-full-screen-button", "button", "button--transparent", "csico-btn");
                    quitFullScreenButton.type = "button";
                    quitFullScreenButton.innerHTML = `<div class="icon ic-cs-times"></div>`;
                    container.appendChild(quitFullScreenButton);
                    this.$Control.append(container);
                    this.quitFullScreenButton = quitFullScreenButton;
                }
                catch (error) {
                    console.error("Error while creating quit full screen elements", error);
                }
            }
            getReversedAnimationDuration(duration) {
                try {
                    const animationDurations = this.animationDurations;
                    const reversedAnimationDurations = [...animationDurations].reverse();
                    const indexOfDuration = animationDurations.indexOf(duration);
                    const reversedDuration = reversedAnimationDurations[indexOfDuration];
                    return reversedDuration;
                }
                catch (error) {
                    console.error("Error while getting animation duration for input", error);
                }
            }
            createDateSelectionElement() {
                try {
                    const elementContainer = document.createElement("div");
                    elementContainer.id = `racing-bar-chart__date-selection-container-${this.controlId}`;
                    elementContainer.classList.add("racing-bar-chart__date-selection-container");
                    elementContainer.style.display = "flex";
                    elementContainer.style.justifyContent = "center";
                    elementContainer.style.alignItems = "center";
                    const element = document.createElement("select");
                    element.id = `racing-bar-chart__date-selector-${this.controlId}`;
                    element.classList.add("racing-bar-chart__date-selector");
                    element.title = "Racing Bar Chart Date Selector";
                    const options = this.dates.map((date) => {
                        const option = document.createElement("option");
                        option.value = date;
                        const dateObject = new Date(date);
                        option.textContent = dateObject.toLocaleDateString(this.lang, {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                        });
                        return option;
                    });
                    options.forEach((option) => {
                        element.appendChild(option);
                    });
                    this.$Control.append(elementContainer);
                    elementContainer.appendChild(element);
                    this.dateSelector = element;
                }
                catch (error) {
                    console.error("Error while creating date selection element", error);
                }
            }
            createProgressBarElement() {
                const element = document.createElement("div");
                element.id = `racing-bar-chart__progress-bar-${this.controlId}`;
                element.classList.add("racing-bar-chart__progress-bar");
                const innerContent = document.createElement("div");
                innerContent.classList.add("racing-bar-chart__progress-bar__inner");
                const fill = document.createElement("div");
                fill.classList.add("racing-bar-chart__progress-bar__fill");
                this.$Control.append(element);
                element.appendChild(innerContent);
                innerContent.appendChild(fill);
                this.progressBar = element;
                const firstKeyframe = this.keyframes[0];
                const firstDate = firstKeyframe[0];
                const lastKeyframe = this.keyframes[this.keyframes.length - 1];
                const lastDate = lastKeyframe[0];
                const totalDiff = lastDate.getTime() - firstDate.getTime();
                let addedDates = [];
                for (let i = 0; i < this.keyframes.length; i++) {
                    const keyframe = this.keyframes[i];
                    if (!keyframe || !keyframe[0] || !keyframe[1]) {
                        continue;
                    }
                    const date = keyframe[0];
                    let isInterpolated = !this.interpolatedDatesByDate.has(this.dateFormat(date));
                    if (!isInterpolated) {
                        isInterpolated = addedDates.includes(this.dateFormat(date));
                    }
                    const diff = date.getTime() - firstDate.getTime();
                    const progress = (diff / totalDiff) * 100;
                    const markerContainer = document.createElement("div");
                    markerContainer.classList.add("racing-bar-chart__progress-marker-container");
                    markerContainer.style.left = `${progress}%`;
                    markerContainer.style.top = `50%`;
                    markerContainer.style.transform = `translate(-50%, -50%)`;
                    markerContainer.dataset.index = i.toString();
                    markerContainer.dataset.progress = progress.toString();
                    markerContainer.dataset.date = this.dateFormat(date);
                    if (isInterpolated) {
                        markerContainer.style.setProperty("display", "none");
                    }
                    const marker = document.createElement("div");
                    marker.classList.add("racing-bar-chart__progress-marker");
                    this.progressBar.appendChild(markerContainer);
                    markerContainer.appendChild(marker);
                    addedDates.push(this.dateFormat(date));
                }
                try {
                }
                catch (error) {
                    console.error("Error while creating progress bar element", error);
                }
            }
            setChartDimensions() {
                return new Promise((resolve, reject) => {
                    try {
                        requestAnimationFrame(() => {
                            var _a, _b;
                            this.chartWidth = ((_b = (_a = this.$Control[0]) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 1) * 1;
                            return resolve();
                        });
                    }
                    catch (error) {
                        console.error("Error while setting chart dimensions.", error);
                        return reject(error);
                    }
                });
            }
            setFallbackHrefs() {
                try {
                    const $images = this.$Control.find(".racing-bar-chart__avatar");
                    if (!$images.length) {
                        return;
                    }
                    $images.each((_, element) => {
                        const $element = $(element);
                        const href = $element.attr("href");
                        const fallbackHref = $element.attr("data-fallback-href");
                        const image = new Image();
                        image.onerror = () => {
                            $element.attr("href", fallbackHref);
                        };
                        if (!CS.Helper.isNullOrWhiteSpace(href)) {
                            image.src = href;
                        }
                    });
                }
                catch (error) {
                    console.error("Error while handling window loaded.", error);
                }
            }
            handleResize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.resizeTimeout) {
                            clearTimeout(this.resizeTimeout);
                        }
                        this.resizeTimeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                            yield this.reset();
                            this.resizeTimeout = null;
                            yield this.setChartDimensions();
                            yield this.reRender(true);
                            this.setState(State.Ready);
                        }), 500);
                    }
                    catch (error) {
                        this.setState(State.Error);
                        console.error("Error while handling resize.", error);
                    }
                });
            }
            render(isResizing) {
                return new Promise((resolve, reject) => {
                    try {
                        requestAnimationFrame(() => __awaiter(this, void 0, void 0, function* () {
                            this.setScale("x");
                            this.setScale("y");
                            if (this.xScale == null || this.yScale == null) {
                                throw new Error("Scales not found.");
                            }
                            this.setSVG();
                            this.appendSVGNode();
                            this.bindUpdateFunctions();
                            yield this.goToKeyframe("index", 0);
                            this.updateLegend();
                            this.setFallbackHrefs();
                            return resolve();
                        }));
                    }
                    catch (error) {
                        console.error("Error while rendering.", error);
                        this.setState(State.Error);
                        return reject(error);
                    }
                });
            }
            bindUpdateFunctions() {
                try {
                    this.updateBars = this._updateBars(this.svg);
                    this.updateAxis = this._updateAxis(this.svg);
                    this.updateLabels = this._updateLabels(this.svg);
                    this.updateTicker = this._updateTicker(this.svg);
                }
                catch (error) {
                    this.setState(State.Error);
                    console.error("Error while assigning update functions.", error);
                }
            }
            appendSVGNode() {
                var _a;
                try {
                    const svgNode = (_a = this.svg) === null || _a === void 0 ? void 0 : _a.node();
                    if (!(svgNode instanceof SVGSVGElement)) {
                        throw new Error("SVG node not found.");
                    }
                    if (!this.chartContainer) {
                        throw new Error("Inner chart element not found.");
                    }
                    this.chartContainer.appendChild(svgNode);
                }
                catch (error) {
                    console.error("Error while appending SVG node.", error);
                }
            }
            setSVG() {
                try {
                    this.svg = d3
                        .create("svg")
                        .attr("viewBox", [0, 0, this.chartWidth, this.chartHeight]);
                }
                catch (error) {
                    console.error("Error while setting SVG.", error);
                }
            }
            setScale(axis) {
                try {
                    if (axis == "x") {
                        this.xScale = d3
                            .scaleLinear()
                            .domain([0, 1])
                            .range([this.marginLeft, this.chartWidth - this.marginRight]);
                    }
                    else {
                        this.yScale = d3
                            .scaleBand()
                            .domain(d3.range(this.renderedBarsCount + 1))
                            .rangeRound([
                            this.marginTop,
                            this.marginTop +
                                this.barHeight * (this.renderedBarsCount + 1 + 0.1),
                        ])
                            .padding(this.barPadding);
                    }
                }
                catch (error) {
                    console.error("Error while setting scale.", error);
                }
            }
            unRender() {
                return new Promise((resolve, reject) => {
                    try {
                        requestAnimationFrame(() => {
                            this.removeSVG();
                            return resolve();
                        });
                    }
                    catch (error) {
                        console.error("Error while un-rendering.", error);
                        return reject(error);
                    }
                });
            }
            removeSVG() {
                try {
                    if (this.svg == null) {
                        throw new Error("SVG not found.");
                    }
                    this.svg.remove();
                }
                catch (error) {
                    console.error("Error while removing SVG node.", error);
                }
            }
            reRender(isResizing) {
                return new Promise((resolve, reject) => {
                    try {
                        this.unRender()
                            .then(() => {
                            this.render(isResizing)
                                .then(() => {
                                return resolve();
                            })
                                .catch((error) => {
                                console.error(error);
                                return reject(error);
                            });
                        })
                            .catch((error) => {
                            console.error(error);
                            return reject(error);
                        });
                    }
                    catch (error) {
                        console.error("Error while re-rendering.");
                        return reject(error);
                    }
                });
            }
            textTween(a, b, numberFormat) {
                const i = d3.interpolateNumber(a, b);
                return function (t) {
                    // @ts-ignore
                    this.textContent = numberFormat(i(t));
                };
            }
            _updateBars(svg) {
                try {
                    let bar = svg.append("g").selectAll("rect");
                    return ([date, data], transition) => (bar = bar
                        .data(data.slice(0, this.renderedBarsCount), (d) => {
                        return d.id;
                    })
                        .join((enter) => enter
                        .append("rect")
                        .attr("class", "racing-bar-chart__bar")
                        .attr("data-id", (d) => d.id)
                        .attr("fill", (d) => {
                        if (this.orangeEntityBaseIds.includes(d.id)) {
                            return this.orangeBarColor;
                        }
                        else if (this.blueEntityBaseIds.includes(d.id)) {
                            return this.blueBarColor;
                        }
                        else if (this.mainHighlightedSymbolIds.includes(d.id)) {
                            return this.mainHighlightedBarColor;
                        }
                        else if (this.secondaryHighlightedSymbolIds.includes(d.id)) {
                            return this.secondaryHighlightedBarColor;
                        }
                        return this.barColor;
                    })
                        .attr("fill-opacity", (d) => {
                        if (d.isSpare) {
                            return this.barFillOpacityIsSpare;
                        }
                        return this.barFillOpacity;
                    })
                        .attr("height", this.yScale.bandwidth())
                        .attr("x", this.xScale(this.minValue))
                        .attr("y", (d) => {
                        try {
                            if (!this.previousItemsMap) {
                                throw new Error("Prev not found.");
                            }
                            return this.yScale((this.previousItemsMap.get(d) || d).rank);
                        }
                        catch (error) {
                            console.error("Error while rendering the bars.", error);
                            this.setState(State.Error);
                            return;
                        }
                    })
                        .attr("width", (d) => {
                        try {
                            if (!this.previousItemsMap) {
                                throw new Error("Prev not found.");
                            }
                            return (this.xScale((this.previousItemsMap.get(d) || d).value) -
                                this.xScale(this.minValue));
                        }
                        catch (error) {
                            console.error("Error while rendering the bars.", error);
                            this.setState(State.Error);
                            return;
                        }
                    }), (update) => update, (exit) => exit
                        .transition(transition)
                        .remove()
                        .attr("y", (d) => {
                        try {
                            if (!this.nextItemsMap) {
                                throw new Error("Next not found.");
                            }
                            return this.yScale((this.nextItemsMap.get(d) || d).rank);
                        }
                        catch (error) {
                            console.error("Error while rendering the bars.", error);
                            this.setState(State.Error);
                            return;
                        }
                    })
                        .attr("width", (d) => {
                        try {
                            if (!this.nextItemsMap) {
                                throw new Error("Next not found.");
                            }
                            return (this.xScale((this.nextItemsMap.get(d) || d).value) -
                                this.xScale(this.minValue));
                        }
                        catch (error) {
                            console.error("Error while rendering the bars.", error);
                            this.setState(State.Error);
                            return;
                        }
                    }))
                        .call((bar) => bar
                        .transition(transition)
                        .attr("y", (d) => this.yScale(d.rank))
                        .attr("width", (d) => this.xScale(d.value) - this.xScale(this.minValue))));
                }
                catch (error) {
                    console.error("Error while updating bars.", error);
                }
            }
            _updateAxis(svg) {
                try {
                    const g = svg
                        .append("g")
                        .attr("transform", `translate(0,${this.marginTop})`);
                    const axis = d3
                        .axisTop(this.xScale)
                        .ticks(this.chartWidth / 100)
                        .tickSizeOuter(0)
                        .tickSizeInner(-this.barHeight * (this.renderedBarsCount + this.yScale.padding()));
                    return (_, transition) => {
                        g.transition(transition).call(axis);
                        // g.select(".tick:first-of-type text").remove();
                        g.selectAll(".tick line").attr("stroke", this.xAxisColor);
                        g.selectAll(".tick text").style("font-size", `${this.baseTextFontSize}px`);
                        g.selectAll(".tick text").style("fill-opacity", 0.5);
                        g.select(".domain").remove();
                    };
                }
                catch (error) {
                    console.error("Error while updating X axis.", error);
                }
            }
            _updateLabels(svg) {
                try {
                    let rightAlignedValueSVG = svg
                        .append("g")
                        .style("font", "bold 12px Open Sans")
                        .style("font-variant-numeric", "tabular-nums")
                        .attr("text-anchor", "start")
                        .selectAll("text");
                    let leftAlignedValueSVG = svg
                        .append("g")
                        .style("font", "bold 12px Open Sans")
                        .style("font-variant-numeric", "tabular-nums")
                        .attr("text-anchor", "end")
                        .selectAll("text");
                    let rankSVG = svg
                        .append("g")
                        .style("font", "bold 12px Open Sans")
                        .style("font-variant-numeric", "tabular-nums")
                        .attr("text-anchor", "start")
                        .selectAll("text");
                    let avatarOutlineSVG = svg
                        .append("g")
                        .attr("text-anchor", "middle")
                        .selectAll("rect");
                    let avatarSVG = svg
                        .append("g")
                        .attr("text-anchor", "middle")
                        .selectAll("image");
                    const valueTextShouldBeOutsideBar = (date, d) => {
                        try {
                            const min = this.minValueForBarInnerTextByDate.get(date);
                            if (isNaN(min)) {
                                throw new Error("Min value not found.");
                            }
                            return d.value < min;
                        }
                        catch (error) {
                            console.error("Error while checking if the label should be left aligned.", error);
                            return false;
                        }
                    };
                    return ([date, data], transition) => {
                        rightAlignedValueSVG = rightAlignedValueSVG
                            .data(data.slice(0, this.renderedBarsCount), (d) => d.id)
                            .join((enter) => enter
                            .append("text")
                            .attr("class", "racing-bar-chart__bar-text")
                            .attr("transform", (d) => {
                            try {
                                if (!this.previousItemsMap) {
                                    throw new Error("Previous and/or next not found.");
                                }
                                const translateX = this.xScale((this.previousItemsMap.get(d) || d).value);
                                return `translate(${translateX},${this.yScale((this.previousItemsMap.get(d) || d).rank)})`;
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return;
                            }
                        })
                            .attr("y", this.yScale.bandwidth() / 2)
                            .attr("dy", "-0.25em")
                            .attr("x", this.spacing * 2 + this.avatarWidth)
                            .text((d) => d.name)
                            .style("font-weight", (d) => {
                            if (d.isSpare) {
                                return "300";
                            }
                            return "600";
                        })
                            .style("font-style", "italic")
                            .style("font-size", `${this.nameFontSize}px`)
                            .style("fill", this.barTextColor)
                            //   .style("opacity", (d: KeyframeDatapoint) => {
                            //     if (d.isSpare) {
                            //       return this.barTextOpacityIsSpare;
                            //     }
                            //     return this.barTextOpacity;
                            //   })
                            .call((text) => text
                            .append("tspan")
                            .attr("font-size", this.valueFontSize)
                            .attr("font-weight", "900")
                            .attr("x", this.spacing * 2 + this.avatarWidth)
                            .attr("dy", "1.15em")), (update) => update, (exit) => exit
                            .transition(transition)
                            .remove()
                            .attr("transform", (d) => {
                            try {
                                if (!this.nextItemsMap) {
                                    throw new Error("Previous and/or next not found.");
                                }
                                const translateX = this.xScale((this.nextItemsMap.get(d) || d).value);
                                return `translate(${translateX},${this.yScale((this.nextItemsMap.get(d) || d).rank)})`;
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return;
                            }
                        })
                            .call((g) => g.select("tspan").tween("text", (d) => {
                            try {
                                if (!this.nextItemsMap) {
                                    throw new Error("Next not found.");
                                }
                                return this.textTween(d.value, (this.nextItemsMap.get(d) || d).value, this.valueNumberFormat);
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return () => { };
                            }
                        })))
                            .call((labels) => {
                            return labels
                                .transition(transition)
                                .attr("transform", (d) => {
                                const translateX = this.xScale(d.value);
                                return `translate(${translateX},${this.yScale(d.rank)})`;
                            })
                                .attr("x", this.spacing * 2 + this.avatarWidth)
                                .attr("opacity", (d) => {
                                return valueTextShouldBeOutsideBar(date, d)
                                    ? d.isSpare
                                        ? this.barTextOpacityIsSpare
                                        : this.barTextOpacity
                                    : 0;
                            })
                                .style("text-shadow", "rgba(0,0,0,0.75) 1px 1px 3px, rgba(0,0,0,0.75) 1px 1px 3px")
                                .call((g) => g.select("tspan").tween("text", (d) => {
                                try {
                                    if (!this.previousItemsMap) {
                                        throw new Error("Prev not found.");
                                    }
                                    return this.textTween((this.previousItemsMap.get(d) || d).value, d.value, this.valueNumberFormat);
                                }
                                catch (error) {
                                    console.error("Error while rendering the labels.", error);
                                    this.setState(State.Error);
                                    return () => { };
                                }
                            }));
                        });
                        leftAlignedValueSVG = leftAlignedValueSVG
                            .data(data.slice(0, this.renderedBarsCount), (d) => d.id)
                            .join((enter) => enter
                            .append("text")
                            .attr("class", "racing-bar-chart__bar-text")
                            .attr("transform", (d) => {
                            try {
                                if (!this.previousItemsMap) {
                                    throw new Error("Previous and/or next not found.");
                                }
                                const translateX = this.xScale((this.previousItemsMap.get(d) || d).value);
                                return `translate(${translateX},${this.yScale((this.previousItemsMap.get(d) || d).rank)})`;
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return;
                            }
                        })
                            .attr("y", this.yScale.bandwidth() / 2)
                            .attr("dy", "-0.25em")
                            .attr("x", this.spacing * -1)
                            // .attr("opacity", (d: KeyframeDatapoint) => {
                            //   return valueTextShouldBeOutsideBar(date, d) ? 0 : 1;
                            // })
                            .text((d) => d.name)
                            .style("font-weight", (d) => {
                            if (d.isSpare) {
                                return "300";
                            }
                            return "600";
                        })
                            .style("font-style", "italic")
                            .style("font-size", `${this.nameFontSize}px`)
                            .style("fill", this.barTextColor)
                            //   .style("opacity", (d: KeyframeDatapoint) => {
                            //     if (d.isSpare) {
                            //       return this.barTextOpacityIsSpare;
                            //     }
                            //     return this.barTextOpacity;
                            //   })
                            .call((text) => text
                            .append("tspan")
                            .attr("font-size", this.valueFontSize)
                            .attr("font-weight", "bold")
                            .attr("x", this.spacing * -1)
                            // .attr("opacity", (d: KeyframeDatapoint) => {
                            //   return valueTextShouldBeOutsideBar(date, d) ? 0 : 1;
                            // })
                            .attr("dy", "1.15em")), (update) => update, (exit) => exit
                            .transition(transition)
                            .remove()
                            .attr("transform", (d) => {
                            try {
                                if (!this.nextItemsMap) {
                                    throw new Error("Previous and/or next not found.");
                                }
                                const translateX = this.xScale((this.nextItemsMap.get(d) || d).value);
                                return `translate(${translateX},${this.yScale((this.nextItemsMap.get(d) || d).rank)})`;
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return;
                            }
                        })
                            .call((g) => g.select("tspan").tween("text", (d) => {
                            try {
                                if (!this.nextItemsMap) {
                                    throw new Error("Next not found.");
                                }
                                return this.textTween(d.value, (this.nextItemsMap.get(d) || d).value, this.valueNumberFormat);
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return () => { };
                            }
                        })))
                            .call((labels) => {
                            return labels
                                .transition(transition)
                                .attr("transform", (d) => {
                                const translateX = this.xScale(d.value);
                                return `translate(${translateX},${this.yScale(d.rank)})`;
                            })
                                .attr("x", this.spacing * -1)
                                .attr("opacity", (d) => {
                                return valueTextShouldBeOutsideBar(date, d)
                                    ? 0
                                    : d.isSpare
                                        ? this.barTextOpacityIsSpare
                                        : this.barTextOpacity;
                            })
                                .style("text-shadow", "rgba(0,0,0,0.75) 1px 1px 3px, rgba(0,0,0,0.75) 1px 1px 3px")
                                .call((g) => g.select("tspan").tween("text", (d) => {
                                try {
                                    if (!this.previousItemsMap) {
                                        throw new Error("Prev not found.");
                                    }
                                    return this.textTween((this.previousItemsMap.get(d) || d).value, d.value, this.valueNumberFormat);
                                }
                                catch (error) {
                                    console.error("Error while rendering the labels.", error);
                                    this.setState(State.Error);
                                    return () => { };
                                }
                            }));
                        });
                        const rankTranslateLeft = 0;
                        rankSVG = rankSVG
                            .data(data.slice(0, this.renderedBarsCount), (d) => d.id)
                            .join((enter) => enter
                            .append("text")
                            .attr("transform", (d) => {
                            try {
                                if (!this.previousItemsMap) {
                                    throw new Error("Prev not found.");
                                }
                                return `translate(${rankTranslateLeft},${this.yScale((this.previousItemsMap.get(d) || d).rank)})`;
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return;
                            }
                        })
                            .call((text) => text
                            .append("tspan")
                            .attr("fill-opacity", 1)
                            .attr("y", this.yScale.bandwidth() / 2)
                            .attr("font-weight", "normal")
                            // .attr("dy", "0.35em")
                            .attr("dy", `${this.baseTextFontSize / 2}px`)
                            .attr("fill", this.rankColor)
                            .style("font-size", `${this.baseTextFontSize}px`)), (update) => update)
                            .call((bar) => bar
                            .transition(transition)
                            .attr("transform", (d) => `translate(${rankTranslateLeft},${this.yScale(d.rank)})`)
                            .call((g) => g.select("tspan").tween("text", (d) => {
                            try {
                                if (!this.previousItemsMap) {
                                    throw new Error("Prev not found.");
                                }
                                return this.textTween((this.previousItemsMap.get(d) || d).rank + 1, d.rank + 1, this.rankNumberFormat);
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return () => { };
                            }
                        })));
                        avatarOutlineSVG = avatarOutlineSVG
                            .data(data.slice(0, this.renderedBarsCount), (d) => d.id)
                            .join((enter) => enter
                            .append("rect")
                            // .attr("xlink:href", (d) => d.avatar)
                            .attr("class", "racing-bar-chart__avatar-outline")
                            .attr("data-id", (d) => d.id)
                            .attr("width", this.avatarWidth + 2)
                            .attr("height", this.avatarWidth + 2)
                            .attr("rx", this.avatarWidth + 2)
                            .attr("ry", this.avatarWidth + 2)
                            .attr("fill", "none")
                            .attr("stroke", (d) => {
                            if (this.orangeEntityBaseIds.includes(d.id)) {
                                return this.orangeBarColor;
                            }
                            else if (this.blueEntityBaseIds.includes(d.id)) {
                                return this.blueBarColor;
                            }
                            else if (this.mainHighlightedSymbolIds.includes(d.id)) {
                                return this.mainHighlightedBarColor;
                            }
                            else if (this.secondaryHighlightedSymbolIds.includes(d.id)) {
                                return this.secondaryHighlightedBarColor;
                            }
                            return "none";
                        })
                            .attr("stroke-width", 2)
                            .style("opacity", (d) => {
                            if (d.isSpare) {
                                return this.avatarOpacityIsSpare;
                            }
                            return this.avatarOpacity;
                        })
                            .attr("x", this.spacing - 1)
                            // .attr("y", this.spacing * 1.5)
                            .attr("y", -1)
                            .attr("transform", (d) => {
                            try {
                                if (!this.previousItemsMap) {
                                    throw new Error("Prev not found.");
                                }
                                return `translate(${this.xScale((this.previousItemsMap.get(d) || d).value)},${this.yScale((this.previousItemsMap.get(d) || d).rank)})`;
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return;
                            }
                        }), (update) => update)
                            .call((bar) => bar
                            .transition(transition)
                            .attr("transform", (d) => `translate(${this.xScale(d.value)},${this.yScale(d.rank)})`));
                        avatarSVG = avatarSVG
                            .data(data.slice(0, this.renderedBarsCount), (d) => d.id)
                            .join((enter) => enter
                            .append("image")
                            // .attr("xlink:href", (d) => d.avatar)
                            .attr("xlink:href", (d) => d.avatar)
                            .attr("class", "racing-bar-chart__avatar")
                            .attr("data-id", (d) => d.id)
                            .attr("preserveAspectRatio", "xMidYMid slice")
                            .attr("clip-path", "circle(50%)")
                            .attr("width", this.avatarWidth)
                            .attr("height", this.avatarWidth)
                            .attr("data-fallback-href", (d) => {
                            return d.avatarFallback;
                        })
                            // .attr("onerror", (d: KeyframeDatapoint) => {
                            //   if (d.avatarFallback) {
                            //     return `this.onerror=null; this.href='${d.avatarFallback}';`;
                            //   }
                            //   return "";
                            // })
                            .style("opacity", (d) => {
                            if (d.isSpare) {
                                return this.avatarOpacityIsSpare;
                            }
                            return this.avatarOpacity;
                        })
                            .attr("x", this.spacing)
                            // .attr("y", this.spacing * 1.5)
                            .attr("y", 0)
                            .attr("transform", (d) => {
                            try {
                                if (!this.previousItemsMap) {
                                    throw new Error("Prev not found.");
                                }
                                return `translate(${this.xScale((this.previousItemsMap.get(d) || d).value)},${this.yScale((this.previousItemsMap.get(d) || d).rank)})`;
                            }
                            catch (error) {
                                console.error("Error while rendering the labels.", error);
                                this.setState(State.Error);
                                return;
                            }
                        }), (update) => update)
                            .call((bar) => bar
                            .transition(transition)
                            .attr("transform", (d) => `translate(${this.xScale(d.value)},${this.yScale(d.rank)})`));
                    };
                }
                catch (error) {
                    console.error("Error while updating labels.", error);
                }
            }
            _updateTicker(svg) {
                try {
                    if (!this.keyframes) {
                        throw new Error("Keyframes not found.");
                    }
                    if (!this.dateSelector) {
                        throw new Error("Date selection element not found.");
                    }
                    return ([date], transition) => {
                        transition.end().then(() => {
                            const formattedDate = this.dateFormat(date);
                            this.dateSelector.value = formattedDate;
                            this.highlightMarker(formattedDate);
                            this.updateLegend(formattedDate);
                        });
                    };
                }
                catch (error) {
                    console.error("Error while updating ticker.", error);
                }
            }
            highlightMarker(date) {
                var _a, _b;
                try {
                    if (!date) {
                        throw new Error("Date not provided.");
                    }
                    if ((_b = (_a = this.$Control) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) {
                        const markers = this.$Control[0].querySelectorAll(".racing-bar-chart__progress-marker-container");
                        markers.forEach((marker) => {
                            marker.classList.remove("racing-bar-chart__progress-marker-container--active");
                        });
                        const markerElement = document.querySelector(`.chart__progress-marker-container[data-date="${date}"]`);
                        if (markerElement) {
                            markerElement.classList.add("chart__progress-marker-container--active");
                        }
                    }
                }
                catch (error) {
                    console.error("Error while highlighting marker.", error);
                }
            }
        }
        Controls.RacingBarChart = RacingBarChart;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=RacingBarChart.js.map
